export default {
  color: 'var(--color-white)',
  background: 'var(--color-primary)',
  size: {
    desktop: 80
  },
  pulse: true,
}